"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _ActionButton = _interopRequireDefault(require("../ActionButton"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SummaryButton = function SummaryButton(_ref) {
  var className = _ref.className,
      isLoading = _ref.isLoading,
      summary = _ref.summary,
      label = _ref.label,
      onClick = _ref.onClick;
  return /*#__PURE__*/_react.default.createElement("small", {
    className: className
  }, summary && /*#__PURE__*/_react.default.createElement("span", {
    className: "u-text--muted"
  }, summary), onClick && /*#__PURE__*/_react.default.createElement(_ActionButton.default, {
    className: (0, _classnames.default)("is-small", "is-dense", {
      "is-inline": summary
    }),
    onClick: onClick,
    loading: isLoading,
    disabled: isLoading
  }, label));
};

var _default = SummaryButton;
exports.default = _default;